import React, {useEffect, useRef} from 'react';
import {useControllerProps} from '../Widget/ControllerContext';
import {ShippingDetails} from './ShippingDetails/ShippingDetails';
import {DeliveryMethodFastFlow} from './DeliveryMethodFastFlow/DeliveryMethodFastFlow';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {classes} from './FastFlow.st.css';
import {FastFlowAnalyticsEventParams} from '../../../domain/utils/analytics.utils';
import {Checkboxes} from '../Checkboxes/Checkboxes';
import {ErrorDialog} from '../ErrorDialog/ErrorDialog';
import {ViolationsAndPlaceOrderButton} from '../ViolationsAndPlaceOrderButton/ViolationsAndPlaceOrderButton';
import {FastFlowForm} from './FastFlowForm/FastFlowForm';
import {BottomMobileSummary, BottomMobileSummaryDataHooks} from '../Summary/BottomMobileSummary/BottomMobileSummary';
import {classes as commonClasses} from '../../../common/common.st.css';
import {MemberOnlyFastFlow} from './MemberOnlyFastFlow/MemberOnlyFastFlow';
import {SecureCheckout} from '../../../common/components/SecureCheckout/SecureCheckout';
import {PaymentAndPlaceOrderSkeleton} from '../CheckoutSteps/Steps/PaymentAndPlaceOrderStep/PaymentAndPlaceOrderSkeleton';
import {SPECS} from '../../../common/constants';
import {useExperiments} from '@wix/yoshi-flow-editor';

export enum FastFlowDataHook {
  root = 'FastFlow.root',
  title = 'FastFlow.title',
  violations = 'FastFlow.violations',
  Loader = 'FastFlow.loader',
}

export const FastFlow = () => {
  const {
    checkoutStore: {cart, cartSummary, modalError},
    navigationStore: {trackEvent},
    checkboxesStore: {shouldShowCheckboxesSection},
    checkoutSettingsStore: {doesFastFlowFormHaveFieldsToDisplay},
    stepsManagerStore: {shouldShowMemberLoginStep},
    isOneColumnView,
  } = useControllerProps();
  const localeKeys = useLocaleKeys();
  const checkboxesRef = useRef<HTMLDivElement>(null);
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);
  useEffect(() => {
    trackEvent(...FastFlowAnalyticsEventParams);
  }, [trackEvent]);

  const shouldShowFastFlowForm = doesFastFlowFormHaveFieldsToDisplay;

  return (
    <div data-hook={FastFlowDataHook.root} className={checkoutUIRevampOrderSummary ? classes.root : undefined}>
      <div className={commonClasses.oneColumnViewPadding}>
        {shouldShowMemberLoginStep ? (
          <MemberOnlyFastFlow />
        ) : (
          <>
            <Text tagName={'h2'} className={classes.title} data-hook={FastFlowDataHook.title}>
              {localeKeys.checkout.place_order_fast_flow.title()}
            </Text>
            {cartSummary ? (
              <>
                <ShippingDetails />
                <DeliveryMethodFastFlow />
                <div
                  className={
                    shouldShowFastFlowForm || shouldShowCheckboxesSection ? classes.section : classes.buttonOnlySection
                  }>
                  {shouldShowFastFlowForm && <FastFlowForm extendedFields={cart.extendedFields} />}
                  <Checkboxes checkboxesRef={checkboxesRef} />
                </div>
              </>
            ) : (
              <PaymentAndPlaceOrderSkeleton dataHook={FastFlowDataHook.Loader} />
            )}
          </>
        )}
      </div>

      {isOneColumnView ? <BottomMobileSummary dataHook={BottomMobileSummaryDataHooks.placeOrderFastFlow} /> : null}
      <ViolationsAndPlaceOrderButton checkboxesRef={checkboxesRef} />
      {isOneColumnView && !checkoutUIRevampOrderSummary && <SecureCheckout />}
      {(cart.noItemsError || modalError) && <ErrorDialog />}
    </div>
  );
};
